<template>
  <div>
    <div class="form">
      <div class="row">
        <div class="col-12">
          <h4>Datos para la firma</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span>Principal:</span>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <input type="text" class="form-control" v-model="principal.nombre" />
        </div>
        <div class="col-9">
          <input type="text" class="form-control" v-model="principal.cargo" />
        </div>
      </div>
      <div class="row new-row">
        <div class="col-12">
          <span>Testigos:</span>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <input type="text" class="form-control" v-model="testigos[0]" />
        </div>
        <div class="col-3">
          <input type="text" class="form-control" v-model="testigos[1]" />
        </div>
      </div>
      <div class="row new-row">
        <div class="col-3">
          <input
            type="number"
            min="0"
            class="form-control"
            v-model="caliberHeight"
          />
        </div>

        <div class="col-3">
          <input
            type="button"
            class="form-control"
            value="Imprimir Reporte"
            @click="generarReporte"
          />
        </div>
      </div>
    </div>
    <div class="lista-acuerdos" id="lista-acuerdos">
      <div class="header">
        <img
          src="../../../../assets/logo-pj-transparente-negro.png"
          alt="Logo de Poder Judicial del Estado de Aguascalientes"
          class="logo"
        />
        <span class="titulo" style="clear: both"
          >SUPERMO TRIBUNAL DE JUSTICIA</span
        ><br />
        <span>Contraloría Interna</span><br />
        <span>Autoridad Investigadora</span><br />
        <span
          >Lista de acuerdos dictada el
          {{
            fechaDeDictado.toLocaleDateString("es-MX", opcionesFechaLocal)
          }}</span
        >
      </div>

      <div
        class="bloque"
        v-for="(acuerdo, indice) in listaDeAcuerdos"
        v-bind:key="acuerdo.acuerdoId"
      >
        <div class="naturaleza">
          <b>INVESTIGACIÓN Y CALIFICACIÓN DE PRESUNTA FALTA ADMINISTRATIVA</b>
        </div>
        <div class="acuerdo">
          <span>{{ indice + 1 }}.</span>
          <b>{{ acuerdo.denuncia.consecutivo }}</b>
          <span
            class="presunto-responsable"
            v-for="persona in acuerdo.denuncia.personas"
            v-bind:key="persona.personaId"
          >
            {{ persona.nombre + " " + persona.paterno + " " + persona.materno }}
          </span>
          <span>{{ acuerdo.extracto }}</span>
        </div>
      </div>
      <div class="footer">
        <span
          >Aguascalientes, Ags a
          {{ date.toLocaleDateString("es-MX", opcionesFechaLocal2) }}</span
        >
        <br /><br /><br /><br />
        <span>{{ principal.nombre }}</span
        ><br />
        <span>{{ principal.cargo }}</span>
        <br /><br /><br /><br />
        <div>
          <table class="testigos">
            <tbody>
              <tr>
                <td>{{ testigos[0] }}<br />Testigo de Asistencia</td>
                <td>{{ testigos[1] }}<br />Testigo de Asistencia</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-bind:style="`height:${parseInt(caliberHeight)}px;`"
        class="caliber-height"
      ></div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
export default {
  data() {
    return {
      listaDeAcuerdos: [],
      fechaDeDictado: new Date(),
      opcionesFechaLocal: { year: "numeric", month: "long", day: "numeric" },
      opcionesFechaLocal2: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      },
      date: new Date(),
      caliberHeight: 0,
      principal: {
        nombre: "C.P. ANA LOURDES MACÍAS BEJARANO",
        cargo:
          "Contralora Interna y Autoridad Investigadora del Poder Judicial del Estado",
      },
      testigos: [
        "Lic. Lourdes Viridiana Marín Ortega",
        "Lic. Rogelio Guzmán Rivera",
      ],
    };
  },
  props: {
    prop_listaDeAcuerdos: Array[Acuerdo],
    prop_fechaDeDictado: String,
  },
  components: {},
  methods: {
    generarReporte: function () {
      var popupWin = window.open("", "_blank", "width=563,height=750");
      popupWin.document.open();
      popupWin.document.write("<html><head><title></title>");
      popupWin.document.write(
        "<style>" +
          ".lista-acuerdos{column-count: 2;background-color: white;padding: 10px;font-family: Calibri, sans-serif;font-size: 10pt;}" +
          ".header{font-size: 14pt;column-span: all;color: black;text-align: center;margin-bottom: 20px;}" +
          ".header span{position: relative;right: 100px;}" +
          ".footer{column-span: none;color: black;text-align: center;margin-top: 10px;break-inside: avoid-column;}" +
          ".naturaleza{text-align: center;color: black;}" +
          ".titulo{font-weight: bolder;}" +
          ".acuerdo {border-width: 1px;border-style: solid;padding: 2px;text-align: justify;}" +
          ".bloque {box-sizing: border-box;color: black;break-inside: avoid-column;column-span: none;}" +
          ".testigos{width: 100%;}" +
          ".testigos td{font-size: 10pt;text-align: center;vertical-align: top;}" +
          ".logo{float: left;width: 200px;}" +
          ".presunto-responsable{color: #808080;}</style>"
      );
      popupWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
      popupWin.document.write(
        '<link href="/static/css/bootstrap.min.css" rel="stylesheet">'
      );
      popupWin.document.write(
        '<link href="/static/css/all.min.css" rel="stylesheet">'
      );
      popupWin.document.write(
        '<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">'
      );
      popupWin.document.write("</head><body >");
      var resultados = document.getElementById("lista-acuerdos").outerHTML;
      popupWin.document.write(resultados);
      popupWin.document.write("</body></html>");

      setTimeout(function () {
        popupWin.print();
      }, 1000);
      popupWin.document.close();
      popupWin.focus();
      this.ImpresionConcluida = true;
    },
  },
  mounted: function mounted() {
    if (this.prop_listaDeAcuerdos)
      this.listaDeAcuerdos = this.prop_listaDeAcuerdos;
    if (this.prop_fechaDeDictado) {
      const dateArray = this.prop_fechaDeDictado.split("-");
      const year = dateArray[0];
      const month = parseInt(dateArray[1], 10) - 1;
      const date = dateArray[2];
      this.fechaDeDictado = new Date(year, month, date);
    }
  },
  computed: {},
};
</script>

<style scoped>
b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.bigtextarea {
  height: 100px;
}
.lista-acuerdos {
  overflow-y: auto;
  column-count: 2;
  background-color: white;
  padding: 10px;
  font-family: Calibri, sans-serif;
  font-size: 10pt;
}
.header {
  font-size: 14pt;
  column-span: all;
  color: black;
  text-align: center;
  margin-bottom: 20px;
}
.header span {
  position: relative;
  right: 100px;
}
.footer {
  column-span: none;
  color: black;
  text-align: center;
  margin-top: 10px;
  break-inside: avoid-column;
}
.naturaleza {
  text-align: center;
  color: black;
}
.titulo {
  font-weight: bolder;
}
.acuerdo {
  border-width: 1px;
  border-style: solid;  
  padding: 2px;
  text-align: justify;
}
.bloque {
  box-sizing: border-box;
  color: black;
  break-inside: avoid-column;
  column-span: none;
}
.presunto-responsable {
  color: grey;
}
.testigos {
  width: 100%;
}
.testigos td {
  font-size: 10pt;
  text-align: center;
  vertical-align: top;
}
.logo {
  width: 200px;
  float: left;
}
.caliber-height {
  border-style: solid;
  border-color: black;
}
.form {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/SIFA/Reportes/ListasDeAcuerdos/VistaPreviaListaDeAcuerdos.vue